import { RoundedCornersType } from './BannerTitle.types';

export const DEFAUL_BORDER_CORNERS: RoundedCornersType = {
  topLeft: true,
  topRight: true,
  bottomLeft: true,
  bottomRight: true,
};
